import { IconProps } from './IconProps'

export const TableEmptyState: React.FC<IconProps> = (props) => {
  const { className, width = 1232, height = 201 } = props

  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 1232 201'
      className={className}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g opacity='0.5'>
        <g clipPath='url(#clip0_39_5778)'>
          <rect
            y='0.5'
            width='1232'
            height='56'
            rx='12'
            fill='var(--text-base-em)'
            fillOpacity='0.7'
          />
          <g opacity='0.1'>
            <rect x='32' y='12.5' width='32' height='32' rx='8' fill='var(--text-black' />
            <g opacity='0.4'>
              <rect x='76' y='23' width='75' height='11' rx='5.5' fill='var(--text-black' />
            </g>
          </g>
          <g opacity='0.1'>
            <rect x='316' y='12.5' width='32' height='32' rx='8' fill='var(--text-black' />
            <g opacity='0.4'>
              <rect x='360' y='23' width='75' height='11' rx='5.5' fill='var(--text-black' />
            </g>
          </g>
          <g opacity='0.1'>
            <g opacity='0.4'>
              <rect x='636' y='23' width='34' height='11' rx='5.5' fill='var(--text-black' />
            </g>
          </g>
          <g opacity='0.1'>
            <g opacity='0.4'>
              <rect x='836' y='23' width='35' height='11' rx='5.5' fill='var(--text-black' />
            </g>
          </g>
          <g opacity='0.1'>
            <g opacity='0.4'>
              <rect x='1120' y='23' width='35' height='11' rx='5.5' fill='var(--text-black' />
            </g>
          </g>
        </g>
      </g>
      <g opacity='0.4'>
        <g clipPath='url(#clip1_39_5778)'>
          <rect
            y='72.5'
            width='1232'
            height='56'
            rx='12'
            fill='var(--text-base-em)'
            fillOpacity='0.6'
          />
          <g opacity='0.1'>
            <rect x='32' y='84.5' width='32' height='32' rx='8' fill='var(--text-black' />
            <g opacity='0.4'>
              <rect x='76' y='95' width='75' height='11' rx='5.5' fill='var(--text-black' />
            </g>
          </g>
          <g opacity='0.1'>
            <rect x='316' y='84.5' width='32' height='32' rx='8' fill='var(--text-black' />
            <g opacity='0.4'>
              <rect x='360' y='95' width='75' height='11' rx='5.5' fill='var(--text-black' />
            </g>
          </g>
          <g opacity='0.1'>
            <g opacity='0.4'>
              <rect x='636' y='95' width='34' height='11' rx='5.5' fill='var(--text-black' />
            </g>
          </g>
          <g opacity='0.1'>
            <g opacity='0.4'>
              <rect x='836' y='95' width='35' height='11' rx='5.5' fill='var(--text-black' />
            </g>
          </g>
          <g opacity='0.1'>
            <g opacity='0.4'>
              <rect x='1120' y='95' width='35' height='11' rx='5.5' fill='var(--text-black' />
            </g>
          </g>
        </g>
      </g>
      <g opacity='0.3'>
        <g clipPath='url(#clip2_39_5778)'>
          <rect
            y='144.5'
            width='1232'
            height='56'
            rx='12'
            fill='var(--text-base-em)'
            fillOpacity='0.5'
          />
          <g opacity='0.1'>
            <rect x='32' y='156.5' width='32' height='32' rx='8' fill='var(--text-black' />
            <g opacity='0.4'>
              <rect x='76' y='167' width='75' height='11' rx='5.5' fill='var(--text-black' />
            </g>
          </g>
          <g opacity='0.1'>
            <rect x='316' y='156.5' width='32' height='32' rx='8' fill='var(--text-black' />
            <g opacity='0.4'>
              <rect x='360' y='167' width='75' height='11' rx='5.5' fill='var(--text-black' />
            </g>
          </g>
          <g opacity='0.1'>
            <g opacity='0.4'>
              <rect x='636' y='167' width='34' height='11' rx='5.5' fill='var(--text-black' />
            </g>
          </g>
          <g opacity='0.1'>
            <g opacity='0.4'>
              <rect x='836' y='167' width='35' height='11' rx='5.5' fill='var(--text-black' />
            </g>
          </g>
          <g opacity='0.1'>
            <g opacity='0.4'>
              <rect x='1120' y='167' width='35' height='11' rx='5.5' fill='var(--text-black' />
            </g>
          </g>
        </g>
      </g>
      <defs>
        <clipPath id='clip0_39_5778'>
          <rect y='0.5' width='1232' height='56' rx='12' fill='white' />
        </clipPath>
        <clipPath id='clip1_39_5778'>
          <rect y='72.5' width='1232' height='56' rx='12' fill='white' />
        </clipPath>
        <clipPath id='clip2_39_5778'>
          <rect y='144.5' width='1232' height='56' rx='12' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
